import { useModelService } from "@shared/services/api/hooks/useModelService";
import { UseQueryOptions } from "react-query";
import { UserBasedFavoriteEventSerializer } from "../types/favorite-events";
import UserBasedFavoriteEventRepository from "../repositories/UserBasedFavoriteEventRepository";

const useUserBasedFavoriteEventService = () => {
  const repository = new UserBasedFavoriteEventRepository();

  const {
    usePaginated,
    useRetrieve,
    useCreate,
    useDelete: useDefaultDelete,
    invalidateAllRepositoryQueries,
    useGenericQuery,
  } = useModelService(repository);

  const useDelete = (
    options?: (typeof useDefaultDelete)["arguments"]["options"]
  ) => {
    return useDefaultDelete({
      options: {
        ...options,
        onSuccess: () => {
          invalidateAllRepositoryQueries();
        },
      },
    });
  };

  const useCheckEvent = (
    eventId: number | undefined,
    {
      options,
    }: {
      options?: UseQueryOptions<UserBasedFavoriteEventSerializer | null>;
    } = {}
  ) => {
    return useGenericQuery<UserBasedFavoriteEventSerializer | null>(
      "checkEvent",
      {
        injects: { eventId },
        options: {
          ...options,
          enabled: options?.enabled !== false && Boolean(eventId),
        },
      }
    );
  };

  return {
    usePaginated,
    useRetrieve,
    useCreate,
    useDelete,
    invalidateAllRepositoryQueries,
    useCheckEvent,
  };
};

export default useUserBasedFavoriteEventService;
